module.exports = __webpack_public_path__ + "quilt1-level3.28f4510f.png";